import { el } from 'redom';

import TextInputRow from 'generics/components/text-input-row';

import OptionsEditor from '../base';
import RequiredInputRow from '../required-input-row';

import {
  isNumber
} from '../utilities';

class NumberFieldOptionsEditor extends OptionsEditor {

  constructor(configuration) {

    super(configuration);

    this.el = el('.number-field-options-editor-main', [
      this.renderPlaceholderInputRow(),
      this.renderRequiredAttributeInputRow(),
      this.renderMinAttributeInputRow(),
      this.renderMaxAttributeInputRow()
    ]);

  }

  renderPlaceholderInputRow() {

    return new TextInputRow({
      label: 'Placeholder',
      placeholder: 'Placeholder text',
      value: this.fieldRow.options.placeholder,
      onChange: this.handlePlaceholderInputChange.bind(this)
    });

  }

  renderRequiredAttributeInputRow() {

    return new RequiredInputRow({
      checked: this.fieldRow.options.required,
      onChange: this.handleRequiredAttributeChange.bind(this)
    });

  }

  renderMinAttributeInputRow() {

    return new TextInputRow({
      type: 'number',
      label: 'Min',
      placeholder: '0',
      value: this.fieldRow.options.min,
      onChange: this.handleMinChange.bind(this)
    });

  }

  renderMaxAttributeInputRow() {

    return new TextInputRow({
      type: 'number',
      label: 'Max',
      placeholder: '100',
      value: this.fieldRow.options.max,
      onChange: this.handleMaxChange.bind(this)
    });

  }

  handlePlaceholderInputChange(event, placeholder) {

    this.fieldRow.options.placeholder = placeholder;

    this.propogateFieldOptionsChange();

  }

  handleMinChange(event, min) {

    if (isNumber(min) === true) {
      this.fieldRow.options.min = parseInt(min, 10);
    } else {
      delete this.fieldRow.options.min;
    }

    this.propogateFieldOptionsChange();

  }

  handleMaxChange(event, max) {

    if (isNumber(max) === true) {
      this.fieldRow.options.max = parseInt(max, 10);
    } else {
      delete this.fieldRow.options.max;
    }

    this.propogateFieldOptionsChange();

  }

  handleRequiredAttributeChange(required) {

    this.fieldRow.options.required = required;

    this.propogateFieldOptionsChange();

  }

}

export default NumberFieldOptionsEditor;
